/*
 * Copyright (c) 2025 curryfirm.com
 */

import { WasteRouteOptimizer } from './WasteRouteOptimizer.js';
import { GOOGLE_MAPS_KEY } from "../../constants.js";

/**
 * Find optimal waste collection route
 * @param {Object} start - Starting location {latitude, longitude}
 * @param {Object} end - Ending location {latitude, longitude}
 * @param {Array} dumpsters - Array of dumpster locations
 * @param {Array} dumps - Array of dump locations
 * @param {Object} options - Supports signal and subsequent arguments
 * @returns {Promise<Object>} Optimized route with sequence and total time
 */
export async function findOptimalToDumpAndBackRoute({ startLoc : start, endLoc : end, dumpsters, dumps, }, options) {
    const { signal } = options;
    const optimizer = new WasteRouteOptimizer(start, end, dumpsters, dumps, GOOGLE_MAPS_KEY);
    await optimizer.precomputeTimeMatrix();
    const result = optimizer.findOptimalRoute();
    const locationSequence = optimizer.getRouteSequence();
    return {
        locationSequence,
        totalLength: result.totalTime,
        dumpsterOrder: result.dumpsterOrder,
        dumpAssignment: result.dumpAssignment
    };
}
